
export class BasicTextStyledProperty {
	public Color: string = "black";
	public FontSize: number = 12;
	public Font: string = "";
	public Italic: boolean = false;
	public Bold: boolean = false;
	public Underline: boolean = false;
	public LineThrough: boolean = false;
	public TextTransform: string = "none"
	public BackgroundColor: string = "none"
	public MarginLeft:number = 0;
	public MarginRight:number = 0;
	public MarginTop:number = 0;
	public MarginBottom:number = 0;
	public PaddingLeft:number = 0;
	public PaddingRight:number = 0;
	public PaddingTop:number = 0;
	public PaddingBottom:number = 0;


	constructor(data?: any) {
		if (!data) {
			return;
		}
		this.Color = data.Color;
		this.Font = data.Font;
		this.FontSize = data.FontSize;
		this.Italic = data.Italic;
		this.Underline = data.Underline;
		this.LineThrough = data.LineThrough;
		this.Bold = data.Bold;
		this.TextTransform = data.TextTransform || "none";
		this.BackgroundColor = data.BackgroundColor || "transparent";
		this.MarginLeft = data.MarginLeft || 0;
		this.MarginRight = data.MarginRight || 0;
		this.MarginTop = data.MarginTop || 0;
		this.MarginBottom = data.MarginBottom || 0;
		this.PaddingLeft = data.PaddingLeft || 0;
		this.PaddingRight = data.PaddingRight || 0;
		this.PaddingTop = data.PaddingTop || 0;
		this.PaddingBottom = data.PaddingBottom || 0;
	}

	public getStyle(): any {
		let val = {
			"color": this.Color,
			"font-weight": this.Bold ? "bold" : "normal",
			"text-decoration": this.Underline ? "underline" : (this.LineThrough ?  "line-through" : "inherit" ),
			"font-style": this.Italic ? "italic" : "normal",
			"text-transform": this.TextTransform,
			"background-color": this.BackgroundColor,
			"margin-bottom": this.MarginBottom + "mm",
			"margin-top": this.MarginTop + "mm",
			"margin-left": this.MarginLeft + "mm",
			"margin-right": this.MarginRight + "mm",
			"padding-bottom": this.PaddingBottom + "mm",
			"padding-top": this.PaddingTop + "mm",
			"padding-left": this.PaddingLeft + "mm",
			"padding-right": this.PaddingRight + "mm",
		} as any;
		val["font-size"] = (this.FontSize || 0) + "pt";
		if (this.Font != "" && this.Font != null) {
			val["font-family"] = this.Font;
		}
		return val;
	}

	public getJSON(): any {
		return {
			Color: this.Color,
			FontSize: this.FontSize,
			Font: this.Font,
			Bold: this.Bold,
			Underline: this.Underline,
			LineThrough: this.LineThrough,
			Italic: this.Italic,
			TextTransform: this.TextTransform,
			BackgroundColor: this.BackgroundColor,
			MarginLeft: this.MarginLeft,
			MarginRight: this.MarginRight,
			MarginTop: this.MarginTop,
			MarginBottom: this.MarginBottom,
			PaddingBottom: this.PaddingBottom,
			PaddingTop: this.PaddingTop,
			PaddingLeft: this.PaddingLeft,
			PaddingRight: this.PaddingRight
		};
	}
}